import styled from "styled-components";
import { Accordion, AccordionDetails, AccordionSummary, IconButton } from "@mui/material";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	> button {
		margin: 0 auto;
	}
`;

export const AccordionSupplier = styled(Accordion)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
		padding: 0.6rem 0;
		margin: 0 0 1rem;

		/* When is Expanded */
		&.MuiAccordion-root.Mui-expanded {
			margin: 0 0 1rem;
		}

		.MuiAccordionSummary-content {
			width: 100%;
		}

		.MuiSvgIcon-root {
			color: ${({ theme }) => theme.pantone2727C};
		}
	}
`;
export const AccordionTitle = styled.h5`
	font-weight: bold;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;
export const AccordionSummarySupplier = styled(AccordionSummary)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
	}
`;
export const AccordionDetailsSupplier = styled(AccordionDetails)`
	&&& {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		background: ${({ theme }) => theme.grayLight};
	}
`;

export const Invoice = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	background: ${({ theme }) => theme.white};
	box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.2);
	padding: 0.8rem 0.4rem;
	width: 100%;
	word-break: break-all;

	> p {
		margin: 0 0 0 0.4rem;
	}
`;

export const ButtonDownloadFile = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantone2727C};
		margin: 0 0 0 auto;
	}
`;

export const BoxLabel = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	position: relative;
`;

export const ContainerLabel = styled.p`
	font-weight: bold;
	margin: 0;
	position: relative;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
`;

export const LabelText = styled.span`
	font-size: 0.9rem;
	font-weight: normal;
	margin: 0 0.2rem 0 0;
`;

export const ButtonEdit = styled.div`
	position: absolute;
	right: 0;
	bottom: 0;
	cursor: pointer;

	path {
		fill: ${({ theme }) => theme.pantone2727C};
	}
`;
